import React from "react";
import moment from "moment";

import { Tooltip } from "antd";
import {
  Role,
  Dot,
  CandidateInfoContainer,
  ShortlistedCandidates,
  RecruiterDetailsContainer,
  JobDetailsContainer,
  CardDetails,
  CandidateDetailsContainer,
  MainContainer,
  CandidateInfo,
  ContestTagDiv,
} from "./styled";

import { Tag, employmentType, locationType } from "../../utils";
import CoffeeDropDown from "../../../../components/coffeeeDropdown";
import { useNavigate } from "react-router-dom";
import { functionService } from "../../../../lib/functions";

const CandidateDetails = ({
  job_loc,
  experience_min,
  experience_max,
  no_position,
  role_type,
  job_loc_type,
  created_at,role_requirements,year_of_exp
}) => {
  return (
    <CandidateInfoContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {job_loc && (
          <>
            <img src="/loc.svg" />
            <CandidateInfo>
              {job_loc.length > 1 ? "Multiple Locations" : job_loc[0]}
            </CandidateInfo>
            {job_loc.length > 1 && (
              <Tooltip
                title={
                  <>
                    {job_loc?.map((currentCity) => (
                      <>
                        {currentCity}
                        <br />
                      </>
                    ))}
                  </>
                }
              >
                <img src="/info.svg" />
              </Tooltip>
            )}
          </>
        )}
      </div>
      {role_requirements!=='TEAM'&&<CandidateInfo>{year_of_exp}</CandidateInfo>}
      {/* {role_requirements!=='TEAM'&&<CandidateInfo>
        {experience_min}-{experience_max} yrs exp.
      </CandidateInfo>} */}
      {role_requirements!=='TEAM'&&<Dot />}
      {/* {no_position && (
        <>
          <CandidateInfo>{no_position} Positions</CandidateInfo>
          <Dot />
        </>
      )} */}

      {/* {role_type && (
        <>
          <CandidateInfo>{employmentType(role_type)}</CandidateInfo>
          <Dot />
        </>
      )} */}

      {/* {job_loc_type && (
        <>
          <CandidateInfo>{job_loc_type.slice(0,1)+job_loc_type.slice(1).toLowerCase()}</CandidateInfo>
          <Dot />
        </>
      )} */}

      {created_at && (
        <CandidateInfo>{moment(created_at).format("Do MMM")}</CandidateInfo>
      )}
    </CandidateInfoContainer>
  );
};

export default function SearchResultCard({ item }) {
  const navigate = useNavigate();
  const {
    request_status,
    id,
    recruiting_role_title,
    no_of_candidate,
    job_loc,
    experience_min,
    experience_max,
    no_position,
    role_type,
    job_loc_type,
    created_at,
    company_name,
    recruiter_name,
    setCandidateList,
    recruiter_id,
    search_id,
    role_requirements,project_type,year_of_exp
  } = item;

  const handleRedirect = () => {
    navigate(`/confirm-candidate/${recruiter_id}/${search_id}/${role_requirements}`);
  };

  const rejectRequest = async () => {
    const { status, response } = await functionService.post(
      "recruiter/change-status",
      {
        search_id: search_id,
        status: "REJECTED",
      }
    );

    if (status) {
      setCandidateList((currentCandidatelist) =>
        currentCandidatelist.map((currentCandidateDetails) => {
          if (currentCandidateDetails.search_id === search_id) {
            return {
              ...currentCandidateDetails,
              request_status: "REJECTED",
            };
          } else {
            return currentCandidateDetails;
          }
        })
      );
    }
  };

  const confirmRequest = async () => {
    const { status, response } = await functionService.post(
      "recruiter/change-status",
      {
        search_id: search_id,
        status: "CONFIRMED",
      }
    );
    if (status) {
      setCandidateList((currentCandidatelist) =>
        currentCandidatelist.map((currentCandidateDetails) => {
          if (currentCandidateDetails.search_id === search_id) {
            return {
              ...currentCandidateDetails,
              request_status: "CONFIRMED",
            };
          } else {
            return currentCandidateDetails;
          }
        })
      );
    }
  };

  const deleteSearch = async () => {
    const { status, response } = await functionService.post(
      "recruiter/delete-search",
      {
        search_id: search_id,
      }
    );

    if (status) {
      setCandidateList((currentCandidatelist) =>
        currentCandidatelist.filter((currentCandidateDetails) => {
          if (currentCandidateDetails.search_id !== search_id)
            return true;
          else
            return false;
        })
      );
    }
  }

  const redirectToRoleDetails = () => {
    navigate(`/confirm-candidate/${recruiter_id}/${search_id}?tab=filter`);
  };

  const redirectToRequestedCandidate = () => {
    navigate(`/confirm-candidate/${recruiter_id}/${search_id}?tab=candidate`);
  };

  const handleChange = ({key}) => {
    switch (key) {
      case "Role details" :
        redirectToRoleDetails();
        return;
      case "Reject request":
        rejectRequest();
        return;

      case "Approve request":
        confirmRequest();
        return;

      case "View requested candidates":
        redirectToRequestedCandidate();
        return;

      case "Delete this search":
        deleteSearch();
        return;

      default:
        return null;
    }
  };

  const actionOptions = [
    "Role details",
    "Reject request",
    "Approve request",
    "View requested candidates",
    "Delete this search"
  ];
  return (
    <MainContainer onClick={handleRedirect}>
      <CardDetails>
        <div>
          <JobDetailsContainer>
            {role_requirements!=='TEAM'&&<Role>
              { recruiting_role_title && recruiting_role_title?.substring(0, 8) === 'CONTEST_' ?
                recruiting_role_title?.split("_")[1]
              :
                recruiting_role_title?.split("_")[0]
              }
            </Role>}

            {role_requirements==='TEAM'&&<Role>Hire dedicated development team - {project_type}</Role>}

            <Tag value={request_status} />
            { recruiting_role_title && recruiting_role_title?.substring(0, 8) === 'CONTEST_' ?
              <ContestTagDiv>Contest</ContestTagDiv>
            : ''
            }
          </JobDetailsContainer>
          <RecruiterDetailsContainer>
            by &nbsp; <span style={{ color: "#1B49EA" }}>{recruiter_name}</span>
            &nbsp; at &nbsp;{" "}
            <span style={{ color: "#1B49EA" }}>{company_name}</span>
          </RecruiterDetailsContainer>
        </div>
       {role_requirements!=='TEAM'&& <ShortlistedCandidates>
          Shortlisted candidates: {no_of_candidate===null?0:no_of_candidate}
        </ShortlistedCandidates>}
      </CardDetails>

      <CandidateDetailsContainer>
        <CandidateDetails
          job_loc={job_loc}
          experience_min={experience_min?experience_min:0}
          experience_max={experience_max?experience_max:0}
          no_position={no_position}
          role_type={role_type}
          job_loc_type={job_loc_type}
          created_at={created_at}
          role_requirements={role_requirements}
          year_of_exp={year_of_exp}
        />
        <div>
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <CoffeeDropDown
              label="Actions"
              optionsList={actionOptions}
              changeHandler={handleChange}
            />
          </span>
        </div>
      </CandidateDetailsContainer>
    </MainContainer>
  );
}
